import {Box, Container, Grid, useMediaQuery, useTheme} from "@material-ui/core";
import {useEffect, useState} from "react";
import {Airfield, defaultAirfield} from "../../models/Airfield";
import {isEmpty} from "../../utils/common";
import {AirfieldService} from "../../services/AirfieldService";
import {useTranslation} from "react-i18next";
import AirfieldDetailsBox from "../../components/airfield/AirfieldDetailsBox";
import AirfieldDetailsBoxMobile from "../../components/airfield/AirfieldDetailsBoxMobile";


const AirfieldDetails = () => {
  const [airfield, setAirfield] = useState<Airfield>(defaultAirfield);
  const { t } = useTranslation();
  const airfieldService = new AirfieldService();
  const currentTheme = useTheme();
  var isSmallMobile = useMediaQuery(currentTheme.breakpoints.down(900));

  useEffect(() => {
    (async () => {
      let airfieldId: string = window.location.href.split('airfieldId=')[1] ?? '';
      if (!isEmpty(airfieldId)) {
        let retrievedAirfield: Airfield = await airfieldService.getAirfieldById(airfieldId);
        setAirfield(retrievedAirfield);
      }
    })();
  }, []);

  return (
    <Container sx={{mt:10}}>
      <Grid
        container
        justifyContent="space-between"
        spacing={3}
      >

        <Grid item>

        </Grid>
      </Grid>
      <Box sx={{ mt: 3 }}>
        {
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              {!isSmallMobile
                && (<><AirfieldDetailsBox airfield={airfield} /></>)}
              {isSmallMobile
                && (<><AirfieldDetailsBoxMobile airfield={airfield} /></>)}
            </Grid>
          </Grid>
        }
      </Box>
    </Container>
  );
}

export default AirfieldDetails;
